import type { AssetId, OutlookSpaceAssetId } from 'owa-timestream-types';
import assetIdMap from './assetIdMap';

export default function updateAssetMap(
    assetId: AssetId,
    serverIdPromise: Promise<OutlookSpaceAssetId>
) {
    assetIdMap.set(assetId, serverIdPromise);
    serverIdPromise
        .then(outlookSpaceAssetId => assetIdMap.set(assetId, outlookSpaceAssetId))
        .catch(() => {
            // if the serverId promise fails, then we gave up trying to create. Do nothing
        });
}
